import Axios from "@/plugins/axios";

export default {
  namespaced: true,

  state: {
    widgets: [],
    error: false
  },
  getters: {
    widgets: state => state.widgets,
    error: state => state.error
  },
  mutations: {
    SET_WIDGETS: (state, payload) => state.widgets = payload,
    UPDATE_WIDGET: (state, token) => {
      const widget = state.widgets.find(w => w.id === token.id);
      if (widget) Object.assign(widget, token);
    },
    SET_ERROR: (state, error) => state.error = error
  },
  actions: {
    all: async ({ commit }) => {
      try {
        const response = await Axios.get("/api/tokens");
        commit("SET_WIDGETS", response.data.reverse());
      } catch (e) {
        commit("SET_ERROR", e);
      }
    },

    get: async ({ commit }, payload) => {
      try {
        const response = await Axios.get(`/api/tokens/${payload}`);
        commit("SET_WIDGETS", response.data);
      } catch (e) {
        commit("SET_ERROR", e);
      }
    },

    create: async ({ commit }, payload) => {
      try {
        await Axios.post("/api/tokens", payload);
        return true;
      } catch (e) {
        commit("SET_ERROR", e);
        return false;
      }
    },

    refresh: async ({ commit }, payload) => {
      try {
        const response = await Axios.post(`/api/tokens/${payload.id}/refresh`);
        commit("UPDATE_WIDGET", {id: payload.id, uuid: response.data.uuid})
        return true;
      } catch (e) {
        commit("SET_ERROR", e);
        return false;
      }
    },

    update: async ({ commit }, payload) => {
      try {
        await Axios.put(`/api/tokens/${payload.id}`, payload);
        return true;
      } catch (e) {
        commit("SET_ERROR", e);
        return false;
      }
    },

    delete: async ({ commit }, payload) => {
      try {
        await Axios.delete(`/api/tokens/${payload}`);
        return true;
      } catch (e) {
        commit("SET_ERROR", e);
        return false;
      }
    },

    deleteChat: async ({ commit }, payload) => {
      try {
        await Axios.delete(`/api/tokens/${payload.token_id}/chat/${payload.chat_id}?source=${payload.source}`);
        return true;
      } catch (e) {
        commit("SET_ERROR", e);
        return false;
      }
    },

    clear: async ({ commit }) => {
      commit("SET_WIDGETS", []);
    }
  }
};
